<!--
  FavorLikes = Favorites + Likes
  --------------------
  设计原则是，不和数据库交互，直接从缓存中去读取。特别注意的是，只能在 show 方法中进行数据初始化，因为这些组件都是默认在 menu 页面加载好的。
  --------------------
  如何取消喜欢
  1. 之前有个极端的想法就是在用户点击 unlike 的时候，发送事件，然后 user likes 控件捕获到这个被删除的 e，然后调用 list.remove(e)。是的，
     想法是很好的，删除的同时，可以精准的停留到当前用户的页面位置。但是别忘了，我现在使用的是 popup entity 弹窗模式，用户不断的点击下一个，
     然后浏览的过程中点击不喜欢，当用户浏览到很后面的时候，这个时候，当再关闭 popup entity 窗口后，用户并不会停留在关闭的 entity 位置，而是在
     之前的位置。-> 也就是说，likes 页面本身采用 popup entity 显示模式，本身就无法精准的停留在某个 entity 位置上，因此，上面的这种做法是多余的！
     还不如直接调用 __doInit 方法进行 reload。TODO 这个需求放在这里吧，将来如果要做，也比较容易。通过 EventBus 跨组件传递事件即可。

-->
<template>
    <div>
        <my-dialog ref="dialog" :title="title" :hide-callback="closeDialogCallback">
            <div align="center">
                <no-signal
                    class="list-wrap"
                    v-if='noSignalVisible'
                    ref="noSignal"
                    display-mode="vertical"
                    :retry-handlers="[retryNextPageHandler()]"
                    :retry-basis="false"
                    :margin-top="50"></no-signal>
                <list ref="list" :next-page-func="nextPage" v-if="hasFavorLikes" :scroll-on-body="false" loading-class="margin-top-20px"></list>
                <div v-else class="margin-top-20px">暂无记录</div>
            </div>
        </my-dialog>
    </div>
</template>

<script>
    import assert from 'assert';
    import MyDialog from "../../commons/MyDialog";
    import IconText from "../../commons/IconText";
    import List from "../../list/List";
    import {DateFormat, getCachedUser, errorMessage, ShowEntityMode, Styles, isPhoneAgent} from "../../../utils";
    import {getEntities} from "../../../data/entity";
    import { TimeoutError, NetworkError } from '@shangyang/error';

    export default {
        name: "UserLikes",
        components: {MyDialog, IconText, List},
        props: {
            title: {
                type: String,
                default: '请输入标题'
            },
            // the user's likes or favorites shortcodes.
            shortcodes: {
                type: Array,
                default: []
            },
            // the unlike/unfavorite global event name, which use to caught the event
            unFavorLikesEventName: {
                type: String,
                default: 'unlikes' // or 'unfavorites'
            },
            // 设置需要 unlike/unfavorite 的 confirm mode，该值需要与 $store 的 mutations 中的 confirm mode 方法名匹配。
            unFavorLikesConfirmModeName: {
                type: String,
                default: 'setUnLikeConfirmMode'  // or 'setUnFavoriteConfirmMode'
            }
        },
        data() {
            return{
                user: null,
                pageNum: 0,
                pageSize: 18, // 一页显示多少个
                hasFavorLikes: false,
                noSignalVisible: false,
            }
        },
        methods: {
            show: function(){
                // 延时显示
                setTimeout(()=>{
                    this.reset();
                    // 这里发现一个非常有意思的特性，就是如果要获得 dialog 中的 list slot 元素，必须在 dialog show 以后并且等待至少一个
                    // tick 的时间，否则（经过无数轮 debug，足足快 2 个小时）list 还没有初始化。由此，我严重的怀疑，el-dialog 的 show
                    // 的逻辑很有可能是使用的是 v-if。因此 this.__doInit() 必须在 timeout 之后执行，否则会因为得不到 list 而报错。
                    this.hasFavorLikes = this.shortcodes.length > 0 ? true: false;
                    this.$refs.dialog.show();
                    this.$nextTick(()=>{
                        if(this.hasFavorLikes){
                            this.__doInit();
                            Styles.bodyScrollLocked = true;
                        }
                    })
                }, 300);
            },
            reset(){
                this.pageNum = 0;
                this.hasFavorLikes = false;
                this.noSignalVisible = false;
            },
            /**
             * 注意事项：
             * 因为 likes/favorites 都是通过 push 向后添加的（包括数据库中的 $addToSet），但是我们需要把后添加的最先显示，因此需要 reverse
             */
            __doInit(){
                console.log('__doInit');
                // 1. 渲染
                async function handle(){
                    // 注意：经过测试发现 _.reverse(shortcodes) 会直接改变 shortcodes 内部的顺序，因此改变顺序之前要 clone
                    let shortcodes = _.clone(this.shortcodes);
                    this.chunks = _.chunk(shortcodes, this.pageSize); // 将 veversed likes 初始化并划分成 chunks。
                    await this.$refs.list.initData(); // initData() 会回调 nextPage 方法
                }
                handle.bind(this)();

                // 2. 监听不再喜欢/收藏事件，实时的将其从 favorlikes 中移除。
                this.$EventBus.$on(this.unFavorLikesEventName, (shortcode) => {
                    async function handle(){
                        // ----------------- 以下便是将 unlike entity 从 list 列表中移除的步骤 ---------------
                        console.log(`caught global ${this.unFavorLikesEventName} event, unlikes entity`, shortcode);
                        let e = this.$store.getters.getCacheEntity(shortcode);
                        assert.ok(e!==undefined || e!==null, 'the entity must be cached if user checked in');
                        // 删除以后，因为 this.poppedEntity 仍然引用的是被删除的 entity，导致 nextEntityHandler() 中无法根据 this.poppedEntity
                        // 定位到下一个 entity，导致点击 next entity 按钮的时候，popped up entity window 异常退出。因此这里的解决方案是，模仿
                        // nextEntityHandler 的做法，先缓存 next e，等待 current e 被删除后，然后销毁当前 popped up Entity 窗口即是被不喜欢的
                        // entity，然后 move to next。因此得到如下 remove 的执行步骤，
                        let list = this.$refs.list;
                        // 1. cache the next e
                        let next = await list.next(e);
                        // 2. delete the current e
                        list.remove(e);
                        // 3. 销毁当前的 entity
                        list.allowPopup = false; // 先销毁 popup popupingEntity window
                        // 4. 展示下一个 entity（如果是手机端则不需要展示下一个）
                        if(next !== null && !isPhoneAgent()){
                            list.showEntity(next.shortcode);
                            // 4.1 最后一个优化是，因为删除后，会造成当前 likes 页面出现空缺，会给人误以为我原本 100 个 likes，只有几个，因此，加载下一页填充这些空缺
                            //     当然这个优化的方式带来的弊端便是，没删除一个就要提前加载 next page。不过没关系，不影响用户体验。
                            this.$refs.list.nextPage();
                        }
                    }
                    handle.bind(this)();
                });

                // 3. 初始化该 dialog 的 display mode；记得一定要在 MyDialog#show() 之后执行。
                this.$store.commit(this.unFavorLikesConfirmModeName, true);
                this.$store.commit('setShowEntityMode', ShowEntityMode.PopupPageMode);
                this.$store.commit('setIsProfileNameNavigble', true);
            },

            closeDialogCallback(){
                console.log('caught hide event, the dialog is closed');
                this.$EventBus.$off(this.unFavorLikesEventName);
                console.log(`the global ${this.unFavorLikesEventName} events get removed from UserFavorLikes`);
                Styles.bodyScrollLocked = false;  // 解锁，注意上锁是在 this.show() 中进行的。
                // @deprecated，由 MyDialog 还原为之前的初始设定。
                // this.$store.commit(this.unFavorLikesConfirmModeName, false); // reset.
            },

            /**
             * 提供 List 组件需要的分页方法调用的句柄.
             * 实现思路是，先从页面缓冲中找，若没有找到，批量的从远程获取，且加载到客户端。
             * @return {Promise}
             */
            async nextPage() {
                try{
                    if(this.chunks[this.pageNum] === undefined) return []; // 如果已经没有下一页了，直接返回空 array
                    // 1. 找出该分页中的 shortcodes 没有加载到客户端的 entities，加载并缓存到客户端
                    let notCached = [];
                    for(let shortcode of this.chunks[this.pageNum]){
                        let e = this.$store.getters.getCacheEntity(shortcode);
                        if(e===undefined || e===null) notCached.push(shortcode);
                    }
                    console.log('user favorlikes, no cached in client side:', notCached);
                    let entities = await getEntities(notCached);
                    for(let e of entities)
                        this.$store.commit('cacheEntity', e);
                    // 2. 然后根据用户缓存的顺序依次输出
                    let page = [];
                    for(let shortcode of this.chunks[this.pageNum]){
                        let e = this.$store.getters.getCacheEntity(shortcode);
                        if(e!==null) page.push(e);
                        else console.warn(`still not retrieve the entity via the shortcode ${shortcode}, this should not happen`);
                    }
                    // 3. move page num to next.
                    this.pageNum++;
                    console.log('user favorlikes next page', page);
                    this.noSignalVisible = false;
                    return page;
                } catch(error){
                    console.error(error);
                    // 如果是第一页就出现了网络异常，将其切换成 main page 异常。
                    if ((error instanceof TimeoutError || error instanceof NetworkError) && this.pageNum === 0) {
                        errorMessage(error.message);
                        this.noSignalVisible = true; // 显示 no signal comp
                        let err = new NetworkError('no signal main page error, has been handled by channel');
                        err.handled = true;  // 通知 List page 我已经处理了，下一级就不要再处理了。
                        throw err;
                    }
                    throw error; // 必须抛出这个异常，否则 List 的 nextPage 调用该句柄的时候会认为是正常返回导致异常
                }
            },

            // the handler for no signal retry usage.
            retryNextPageHandler(){
                return this.$refs.list.nextPage
            },
        }
    }
</script>

<style scoped>

    /*/deep/ .list-wrap{*/
    /*    height: 540px; !* 这个属性异常的关键，限制 list 的高度，否则在 PC 端 mugen-scroll 不会触发 next page *!*/
    /*}*/

    /deep/ .el-divider--horizontal{
        margin: 0 !important;
    }

    /*@media (min-width: 401px) and (max-width: 735px){*/
    /*    /deep/ .list-wrap{*/
    /*        height: 540px !important; !* 这个属性异常的关键，否则在移动端 mugen-scroll 不会触发 next page *!*/
    /*    }*/
    /*    /deep/ .el-dialog--center .el-dialog__body{*/
    /*        padding: 2px 2px 2px 2px !important;*/
    /*    }*/
    /*}*/

    /*!*!* small mobile screen *!*!*/
    /*@media (max-width: 400px) {*/
    /*    /deep/ .list-wrap{*/
    /*        height: 440px !important; !* 这个属性异常的关键，否则在移动端 mugen-scroll 不会触发 next page *!*/
    /*    }*/
    /*    /deep/ .el-dialog--center .el-dialog__body{*/
    /*        padding: 2px 2px 2px 2px !important;*/
    /*    }*/
    /*}*/


</style>



// WEBPACK FOOTER //
// src/components/user/center/UserFavorLikes.vue